import { useContext, useEffect, useState } from 'react';
import { $http } from '../plugins';
import { GlobalContext } from '../store';
import { SET_SYSTEM } from '../store/types';

export const useInitialization = () => {
  const [loading, setLoading] = useState(false);
  const { dispatch, state } = useContext(GlobalContext);

  return { loading };
};
